import { render, staticRenderFns } from "./ElectricalCMS.vue?vue&type=template&id=72b3e19b&scoped=true"
import script from "./ElectricalCMS.vue?vue&type=script&lang=js"
export * from "./ElectricalCMS.vue?vue&type=script&lang=js"
import style0 from "./ElectricalCMS.vue?vue&type=style&index=0&id=72b3e19b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3e19b",
  null
  
)

export default component.exports